import {createContext} from 'react';

import type {TrailMark} from '../utils/testRunState';

/**
 * Steps the on-screen test run reached (`testRunState().trail`), from stored steps only: still outlines, no pulse,
 * no "current" card. Empty once the strip closes or a step or connection changed since the test started.
 */
export const TestRunTrailContext = createContext<ReadonlyMap<string, TrailMark>>(new Map());

/** The on-screen test run finished with emails sent: passed outlines show green instead of orange. */
export const TestRunSucceededContext = createContext(false);
